import { IoMdClose } from "react-icons/io";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import makeRequest from "services/makeRequest";
import { routes } from "routes/apiRoutes";
import { formatPhoneNumber, isSuccessResponse, setAlert } from "utils/helper";
import { Modal, Typography, Button, TextField, Loader } from "components";

const AddAccountModal = ({
  isModalVisible,
  setIsModalVisible,
  setIsNotificationModalVisible,
}) => {
  const { user } = useSelector((state) => state.user);

  const [pmNumber, setPmNumber] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [pmNumberValidity, setPMNumberValidity] = useState({
    isValid: null,
    error: "",
    loading: false,
    accountName: "",
  });

  const { isValid, error, loading } = pmNumberValidity;

  const handleChange = (e) => {
    const val = e.target.value;

    setPMNumberValidity({
      ...pmNumberValidity,
      error: "",
      isValid: null,
    });

    if (val.length < 12) {
      setPmNumber(val);
    }

    if (val.length === 11) {
      validatePmNumber(val);
    }
  };

  const validatePmNumber = async (pmNumber) => {
    setPMNumberValidity({
      ...pmNumberValidity,
      loading: true,
      isValid: null,
      error: "",
      accountName: "",
    });
    try {
      const { data } = await makeRequest("post", routes.pmNumberValidation(), {
        pmNumber: formatPhoneNumber(pmNumber),
        isAuthenticated: false,
      });
      if (isSuccessResponse(data)) {
        setPMNumberValidity({
          ...pmNumberValidity,
          loading: false,
          isValid: true,
          error: "",
          accountName: data.data.name,
        });
      } else {
        setPMNumberValidity({
          ...pmNumberValidity,
          isValid: false,
          error: "PM Number not found, Enter a valid Number",
        });
      }
    } catch (error) {
      setPMNumberValidity({
        ...pmNumberValidity,
        loading: false,
      });
    }
  };

  const addPMNumber = async () => {
    setIsSubmitting(true);
    try {
      const { data } = await makeRequest("post", routes.addPmNumber(), {
        agentId: user.agent_id.toString(),
        accountName: pmNumberValidity.accountName,
        accountNumber: formatPhoneNumber(pmNumber),
      });

      if (isSuccessResponse(data)) {
        setIsModalVisible(false);
        setIsNotificationModalVisible(true);
      } else {
        setAlert(data.responseMessage);
      }
      setIsSubmitting(false);
    } catch (error) {}
  };

  return (
    <Modal
      showModal={isModalVisible}
      customPadding={"0"}
      onClose={() => setIsModalVisible(false)}
    >
      <div className="add-account-modal">
        <div className="header">
          <div className="d-flex justify-content-end ">
            <IoMdClose
              className="cursor-pointer"
              onClick={() => setIsModalVisible(false)}
            />
          </div>
          <Typography variant="body0" state="primary" className={"text-center"}>
            Add Account
          </Typography>
          <Typography variant="caption0" className="text-center">
            Add an existing PM Number to your account
          </Typography>
        </div>
        <div className="body p-4">
          <div className="mb-3">
            <TextField
              name="pmNumber"
              type="number"
              placeholder="Enter PM Number"
              label="PocketMoni Phone Number"
              disabled={loading}
              value={pmNumber}
              onChange={handleChange}
            />
            {isValid && (
              <Typography variant="caption1" state="success">
                Pm Number exists, Account Name - {pmNumberValidity.accountName}
              </Typography>
            )}

            {isValid === false && (
              <Typography variant="caption1" state="danger">
                {error}
              </Typography>
            )}

            {loading && (
              <Typography variant="caption1" state="secondary">
                Validating PM Number{" "}
                <span style={{ marginLeft: "1rem" }}>
                  <Loader
                    variant="secondary"
                    height={3}
                    width={1}
                    margin={-12}
                    color="#1966FC"
                  />
                </span>
              </Typography>
            )}

            <Typography variant="caption1">Example: 08037589252</Typography>
          </div>
        </div>
      </div>
      <div className="footer d-flex justify-content-center align-items-center pb-4">
        <Button
          label="Cancel"
          variant="secondary"
          size="sm"
          onClick={() => setIsModalVisible(false)}
        />{" "}
        &nbsp; &nbsp;
        <Button
          label="Add"
          size="sm"
          onClick={addPMNumber}
          disabled={!pmNumberValidity.accountName || !pmNumberValidity.isValid}
          loading={isSubmitting}
        />
      </div>
    </Modal>
  );
};

export default AddAccountModal;
